import "./index.scss"
import "@ungap/custom-elements"

import App from "common/App"

new App()